import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext({});

export function SearchContextProvider({ children }) {
  const [filteredItems, setFilteredItems] = useState([]);

  return (
    <Context.Provider value={{
      filteredItems,
      setFilteredItems,
    }}
    >
      {children}
    </Context.Provider>
  );
}

SearchContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.node,
  ]),
};

export default Context;
